import React, { forwardRef } from "react";
import "./IconButton.css";

interface IconButtonProps {
  icon: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({ 
  icon, 
  onClick, 
  disabled = false,
  ariaLabel,
  className = '',
  style
}, ref) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  const buttonClass = `icon-button ${disabled ? 'disabled' : ''} ${className}`.trim();

  return (
    <button 
      ref={ref}
      className={buttonClass}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel}
      style={style}
      type="button"
    >
      {icon}
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton; 